module.exports = __webpack_public_path__ + "open-sans-v17-latin-800.woff2?ab3e500e7375695d702cff19513e4470";